import { useMemo } from "react";

import { OutcomeAssessmentTable } from "./OutcomeAssessmentTable";

import { useFetchAndSelectMyAssessmentsInOrg } from "components/materials/course/assessment/assessment-data";
import { t } from "i18n/i18n";
import { useAppSelector } from "store/index";
import {
  NestedCourseOutcomeType,
  selectCurrentCourseId,
  selectPagesWithAssessmentsForOutcomeAndUser,
} from "store/selectors";
import { useListSelector } from "store/store-hooks";

/**
 * Displays assessment data from other courses for the given outcome,
 * filtered to exclude the current course.
 */
// TODO: This component loads its data in rather inefficient manner.  It loads all the data from all it's courses
// one course at a time.  We really should just have make one query that returns the summarized data we need for all courses.
export const StudentOtherCourseOutcomeUseIndex = ({
  courseOutcome,
}: {
  courseOutcome: NestedCourseOutcomeType;
}) => {
  const currentCourseId = useAppSelector(selectCurrentCourseId);
  const allPagesWithAssessments = useListSelector((s) =>
    selectPagesWithAssessmentsForOutcomeAndUser(s, courseOutcome.outcome_id),
  );

  const otherCoursePages = useMemo(() => {
    if (!currentCourseId) return [];
    return allPagesWithAssessments.filter((page) => page.course_id !== currentCourseId);
  }, [allPagesWithAssessments, currentCourseId]);

  useFetchAndSelectMyAssessmentsInOrg();

  if (!otherCoursePages.length) return null;

  return (
    <OutcomeAssessmentTable
      data={otherCoursePages}
      title={t("assessment_dashboard.student_outcome_page_list.other_title")}
      showCourseColumn
    />
  );
};
